import React, { Dispatch, SetStateAction, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, SxProps, Typography } from '@mui/material';
import LeaveWarningIcon from 'app/components/Icons/LeaveWarningIcon';
import { black1 } from 'app/components/ThemeProvider/colors';
import { useSearchParams } from 'react-router-dom';
import { closeBtn } from 'app/components/Filter/Filter.sx';
import CloseIcon from 'app/components/Icons/CloseIcon';
import SaveTemplate from 'app/components/SaveTemplate';

interface Props {
  open?: any;
  close?: any;
  handleLeavePage?: any;
  pageName?: any;
  setChangeNameModal?: any;
  showTemplate?: any;
}

const LeaveModal = (props: Props) => {
  const { open, close, handleLeavePage, pageName, setChangeNameModal, showTemplate } = props;

  return (
    <Dialog
      open={open}
      onClose={() => close(false)}
      PaperProps={{
        sx: {
          borderRadius: '8px',
          width: '517px',
          maxHeight: 'none',
        },
      }}
    >
      <Button
        color={'tertiary'}
        onClick={() => {
          close(false);
        }}
        sx={closeBtn}
      >
        <CloseIcon />
      </Button>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <LeaveWarningIcon sx={{ mb: '28px', mt: '20px' }} />
        <Typography sx={{ color: black1, fontSize: '20px', mb: '12px', textAlign: 'center' }}>
          Səhifəni tərk etdiyiniz halda daxil etdiyiniz bütün məlumatlar silinəcək.
        </Typography>
        <Typography sx={{ color: black1, fontSize: '20px', fontWeight: '600' }}>Əminsiniz mi?</Typography>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center', gap: '12px', mb: '40px', p: '0 24px' }}>
        {showTemplate && (
          <Button
            color="secondary"
            onClick={() => {
              setChangeNameModal(true);
              close(false);
            }}
          >
            Şablon kimi yadda saxla
          </Button>
        )}
        <Button color="primary" sx={!showTemplate && { width: '100%' }} onClick={() => handleLeavePage(pageName)}>
          Bəli
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveModal;
